export default "__VITE_ASSET__SSKgjViP__"